exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Colors */\n/* Sizes */\n/* Breakpoints */\n/* Mobile */\n/* Fonts */\n.mobile-layout[data-v-70371eab] {\n  flex: 100%;\n  min-height: 1px;\n  background-color: #fff;\n}\n", ""]);



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/eslint-loader??ref--0!./src/layouts/MobileLayout.vue?vue&type=style&index=1&id=70371eab&lang=scss&scoped=true&
// module id = hoLq
// module chunks = 3